export default __webpack_public_path__ + "static/media/magic-icon.ff706685.svg";